module.exports = Em.Component.extend({
    classNames: ['fixed-assets-list']
})
